module.exports = __webpack_public_path__ + "static/img/empty-data.7564152.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/empty-data.png
// module id = DTpk
// module chunks = 1